import React from "react";
import CardWithCost from "../GeneralCards/CardWithCost";
import gearIcon from "../../../images/gameplay_ui/icons/gear_icon.svg";
import AddRemoveButtons from "../AddRemoveButtons";
import GameWindowHeader from "../GameWindowHeader";
import {LOCO_HEADER_COLOR} from "../GameStyleUI";
import GameWindowBg from "../GameWindowBg";
import {REPAIR_SHOP_NAMES} from "../../../constants/Constants";
import {GetBrigadeCost, GetSparePartCost} from "../../../gameplay/model/Balance";

export default class InvestRepairCard extends React.Component{
    addSparePart(diff){
        let state = this.props.parent.state;
        state.runtimeData.repairData[this.props.repairShop.id].spareParts = diff;

        this.props.parent.setState(state);
    }
    addBrigades(diff){
        let state = this.props.parent.state;
        state.runtimeData.repairData[this.props.repairShop.id].brigades = diff;

        this.props.parent.setState(state);
    }
    initRepairCards(repairShop){
        let styleContainer ={
            padding: "4px",
            display: "flex",
            justifyContent: "space-between"
        }
        let cards = [];
        let state = this.props.parent.state;
        let parts = state.runtimeData.repairData[this.props.repairShop.id].spareParts;
        let brigades = state.runtimeData.repairData[this.props.repairShop.id].brigades;
        let colors = LOCO_HEADER_COLOR[repairShop.partsType];
        let cost = GetBrigadeCost(true);
        cards.push(
            <div key={`invest-card-1`}>
                <CardWithCost cost={cost} colors={colors} title={"Ремонтные бригады"} headerHeight={36} height={40} width={128}/>
                <AddRemoveButtons
                    width={128}
                    colors={colors}
                    disabled={this.props.disabled}
                    value={repairShop.brigades}
                    currentRuntime={brigades}
                    onValueChanged={this.addBrigades.bind(this)}
                    isCanBuy={!this.props.disabled && (cost <= this.props.parent.getAvailableCash() || brigades < 0)}
                    isCanSell={!this.props.disabled && ((cost <= this.props.parent.getAvailableCash() && repairShop.brigades + brigades !== 0) || brigades > 0)}
                />
            </div>);

        cost = GetSparePartCost(true);
        cards.push(
            <div key={`invest-card-2`}>
                <CardWithCost cost={cost} icon={gearIcon} iconSize={16} colors={colors} title={"Запасные части"} headerHeight={36} height={40} width={128}/>
                <AddRemoveButtons
                    width={128}
                    colors={colors}
                    disabled={this.props.disabled}
                    value={repairShop.partsCount}
                    currentRuntime={parts}
                    onValueChanged={this.addSparePart.bind(this)}
                    isCanBuy={!this.props.disabled && cost <= this.props.parent.getAvailableCash()}
                    isCanSell={!this.props.disabled && parts > 0}
                />
            </div>);
        return <div style={styleContainer}>{cards}</div>;
    }

    render() {
        if(!this.props.parent.state.runtimeData.repairData)
            return "";
        let repairShop = this.props.repairShop;
        let colors = LOCO_HEADER_COLOR[repairShop.partsType];
        return <div>
            <GameWindowHeader
                width={271}
                height={30}
                title={REPAIR_SHOP_NAMES[repairShop.partsType]}
                colorStart={colors[0]}
                colorEnd={colors[1]}
                fontSize={12}
                lineHeight={10}
                positionTop={10}
                positionLeft={5}
            />
            <GameWindowBg width={271} height={105} color={"#F2F2F2"} value={this.initRepairCards(repairShop)}/>
        </div>
    }
}
